import React from 'react';

type SaveUpBadgeProps = {
  className?: string;
};

export const SaveUpBadge = ({ className = '' }: SaveUpBadgeProps) => {
  return (
    <div
      className={`text-12 text-center w-fit text-blue-500 bg-blue-100 rounded-full px-2 ml-2 py-1 ${className}`}
    >
      Save up to 20%
    </div>
  );
};
